<script>
import { mapState, mapGetters } from 'vuex'
import AccordionButton from '@components/accordion-button'
import deepLink from '@/mixins/deeplink.js'
import rappiUtils from '@/mixins/utils.js'
import SubHeader from '@components/sub-header'
import GTM_CONSTANTS from '@constants/google-tag-manager'
import AMPLITUDE from '@constants/amplitude'

export default {
  name: 'HelpOptions',
  components: {
    AccordionButton,
    SubHeader,
  },
  mixins: [rappiUtils(), deepLink()],
  props: {
    token: {
      type: String,
      required: true,
    },
    componentData: {
      type: Object,
      required: true,
    },
    userCountry: {
      type: String,
      required: true,
    },
  },
  data () {
    return {}
  },
  computed: {
    ...mapGetters('widgets', ['widgetProperty', 'userEnv']),
    ...mapState('widgets', {
      user: state => state.common.user,
    }),
    ...mapGetters('widgets', ['widgetProperty']),
    obtainOnlyArticles () {
      return this.componentData.complaintTypes.filter(
        ct => ct.button_action === 'load-article'
      )
    },
    complaintOptionsByOS () {
      return this.user.os === 'Android'
        ? this.componentData.complaintTypes
        : this.obtainOnlyArticles
    },
    orderData () {
      return this.widgetProperty('SharedData', 'orderData')
    },
    calificationValue () {
      return this.widgetProperty('Rate', 'value')
    },
    payloadForlogs () {
      const payload = Object.assign({}, this.$route.params, this.$route.query)
      delete payload.token;

      return payload
    },
  },
  created () { },
  methods: {
    validateDeepLinkToCall (complaintType) {
      this.$gtm.trackEvent({
        event: GTM_CONSTANTS.LOG_EVENT,
        noninteraction: 'SELECT_ARTICLE',
        payload: complaintType,
        eventType: 'SELECT_ARTICLE',
        user: this.user,
      })
      if (complaintType.button_action === 'load-article') {
        this.calificateOrder(
          this.token,
          this.orderData.id,
          this.calificationValue,
          [complaintType.article_id]
        )
          .then(order => {
            return this.finalizeOrder(this.token, this.orderData.id)
          })
          .then(order => {
            this.$emit('onChildChange', { fetching: false })
            this.goToArticleBuilder(complaintType.article_id)
          })
          .catch(err => {
            this.dispatchEventTrack(
              AMPLITUDE.SERVER_ERROR,
              JSON.parse(JSON.stringify(err))
            )
            this.$emit('onChildChange', { fetching: false })
            this.goToArticleBuilder(complaintType.article_id)
          })
      } else {
        this.callDeepLink('goto=help_center')
      }
    },
    dispatchEventTrack (eventName, payload = this.payloadForlogs) {
      this.$gtm.trackEvent({
        event: GTM_CONSTANTS.LOG_EVENT,
        noninteraction: eventName,
        payload,
        eventType: eventName,
        user: this.userForLogs,
      })
    },
  },
}
</script>

<template>
  <div
    v-if="widgetProperty('HelpOptions', 'show')"
    :class="$style.container"
  >
    <h4>{{ componentData.title || $t('WIDGETS.HELP_OPTIONS.TITLE') }}</h4>

    <AccordionButton
      v-for="complaintType in componentData.complaintTypes"
      :key="complaintType.title"
      :complaint-type="complaintType"
      @click="validateDeepLinkToCall(complaintType)"
    />
  </div>
</template>


<style scoped lang="scss" module>
@import '@design';

.container {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  width: auto;
  padding: 1rem 1rem 0 1rem;
  margin: 1rem;
  background-color: $white;
  border-radius: 15px;
}

h4 {
  @extend %typography-medium;

  margin: 1rem 0 1.5rem 0;
  font-weight: bold;
  color: $darker-gray;
}

button {
  background: transparent;
}
</style>
